import React, { memo } from "react";
import ModuleTabContent from "components/layout-components/ModuleTabContent";
import FacilityTablets from "./FacilityTablets";
import StaffTokens from "./StaffTokens";
import Roster from "./Roster";
import Timesheet from "./Timesheet";

// Tabs (titles/order) are in NavigationConfig's "workpulse" entry.
//
// Settings (Facility Configuration) carries pairing tokens for whole facilities, so it's
// normally restricted to the client's top-level admin — same "is_super_admin" flag already
// used to gate the other sensitive admin pages. TEMPORARILY shown to everyone, as on master;
// to restore, drop the "facility-tablets" screen for non-super-admins (and its nav tab).
const screens = {
  "facility-tablets": <FacilityTablets />,
  "staff-tokens": <StaffTokens />,
  roster: <Roster />,
  timesheet: <Timesheet />,
};

const Workpulse = () => <ModuleTabContent navKey="workpulse" screens={screens} framed />;

export default memo(Workpulse);
